export const environment = {
  production: false,
  baseUri:'https://r1apimdev01.azure-api.net/FileCapture/',
  capchaSiteKey: '6Ld5FkYkAAAAABYcPFIrzpCddXakRGMrLdy04nGA',
  subscriptionKey: 'd4be0abce4b84fafab20572ca22e4709'
};

